import { defineStore } from 'pinia';
import { UldkasulikToo } from '@/models/UldkasulikToo';

export type UldkasulikTooState = {
  uldkasulikToo: Array<UldkasulikToo>;
  uldkasulikTooSaadud: boolean;
};

export const useUldkasulikTooStore = defineStore('uldkasulikTooStore', {
  state: () => {
    return {
      uldkasulikToo: new Array<UldkasulikToo>(),
      uldkasulikTooSaadud: false,
    } as UldkasulikTooState;
  },
  persist: { storage: sessionStorage },
  actions: {
    satiUldkasulikToo(dto: Array<UldkasulikToo>) {
      this.uldkasulikToo = { ...dto };
      this.uldkasulikTooSaadud = true;
    },
    eemaldaUldkasulikToo() {
      this.uldkasulikToo = new Array<UldkasulikToo>();
      this.uldkasulikTooSaadud = false;
    }
  },
});
